'use client'

import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { useIOSGeolocation } from './iOS-geolocation'
import { useWebGeolocation } from './web-geolocation'
import { useMapBridge } from '../bridge'
import { TCoordinates } from '../map-manager'

export const useGeolocation = () => {
  const t = useTranslations('map')

  const { bridge } = useMapBridge()

  const { getWebUserLocation } = useWebGeolocation()
  const { getIOSUserLocation } = useIOSGeolocation()

  const handleGeolocationError = (error: GeolocationPositionError) => {
    if (error.code === error.PERMISSION_DENIED) {
      alert(t('geolocation.error.permission_denied'))
    } else {
      alert(t('geolocation.error.default'))
    }
  }

  const getGeolocationPosition = async () => {
    try {
      let coordinates: TCoordinates | null = null

      if (bridge?.environment.platform === 'ios') {
        coordinates = await getIOSUserLocation()
      } else {
        coordinates = await getWebUserLocation()
      }

      return convertToLatLng(coordinates)
    } catch (error) {
      if (error instanceof GeolocationPositionError) {
        handleGeolocationError(error)
      } else {
        alert(t('geolocation.error.default'))
      }

      return null
    }
  }

  const convertToLatLng = (position: TCoordinates | null) => {
    if (isNull(position)) {
      return null
    }

    return new naver.maps.LatLng(position.lat, position.lng)
  }

  return {
    getGeolocationPosition,
  }
}
